export const mockPosts = [
  {
    id: 1,
    title: "摩洛哥主帅回应质疑：我记得1998年法国队也踢得磕磕绊绊",
    summary:"摩洛哥主帅回应质疑",
    content: `摩洛哥在非洲杯刚刚1-0战胜了坦桑尼亚进入八强，但球队的踢法和风格一直饱受外界质疑。对此主帅雷格拉吉在近日进行了回应。

"我从小在法国长大，我还记得1998年世界杯，法国队也踢得磕磕绊绊，他们当时在淘汰赛中险胜巴拉圭，并通过点球大战晋级半决赛。在半决赛中，他们一度0-1落后于克罗地亚，而他们的右后卫（图拉姆），一个此前从未进过球的球员，却在那场比赛中打进了两个球。"雷格拉吉说。

"如果我们想成为一支在非洲杯夺冠的球队，就必须从这些比赛中吸取教训。"`
  },
  {
    id: 2,
    title: "朗斯主帅力挺乌多尔进法国队，后者曾4次遭遇十字韧带断裂",
    summary: "乌多尔进法国队",
    content: "虎扑12月31日讯 法甲领头羊朗斯的主教练皮埃尔-萨热，今天下午出席新闻发布会时表示，希望看到球队后卫马蒂厄-乌多尔入选法国队。乌多尔的职业生涯让人想起乔纳森·克劳斯，后者同样在效力于朗斯的后期崭露头角，并最终成为法国队的常客。"

  },
  {
    id: 3,
    title: "安德里希：希望勒沃库森本赛季德国杯能夺冠，德甲进入前四",
    summary: "勇者希望在德国杯能夺冠，德甲进入前四",
    content: "虎扑01月08日讯 勒沃库森队长罗伯特-安德里希近日接受了天空体育的独家专访，在此之中他谈到了自己的角色、与药厂的目标、国家队的变革，并比较了尤尔曼德和哈维-阿隆索的区别.“作为队长，我的角色是确保球队团结一致，并且在场上和场下都能发挥出色。我希望我们能在本赛季的德国杯中夺冠，同时在德甲联赛中进入前四名。”安德里希说道.目标与赛季初相比并没有根本性的改变。我们讨论过，希望在德国杯尽可能走得远——最好是能夺冠，我们完全有机会。我们在欧冠中经历了一个糟糕的开局后，我们仍然完全在其中。在德甲我们也符合预期，前四名，不应低于这个排名。这没有改变，我们在所有赛事中都全力参与，我们当然希望保持这种状态。"
  },
 
];